import * as React from 'react';

import styles from './index.module.sass';

export const AlmostSoldOut = () => (
  <div className={styles.container}>Almost Sold Out</div>
);
